export default __webpack_public_path__ + "static/media/上门喂养勋章@2x.fdd52208.png";